import { decimal, money, taxRate } from '@/js/shared/billables/decimal';
import { documentShippingAmount } from '@/js/shared/billables/document_shipping';

export function calculatePurchaseOrderTotals({ items, tax, documentShipping, payments }) {
  const subtotal = money(items.reduce((sum, item) => sum.plus(money(item.total)), decimal(0)));
  const shippingAmount = documentShippingAmount(subtotal, documentShipping);
  const taxAmount = calculateTaxAmount(items, shippingAmount, tax);
  const total = subtotal.plus(taxAmount).plus(shippingAmount).round(2);

  return {
    subtotal: subtotal.toFixed(2),
    tax: taxAmount.toFixed(2),
    shipping: shippingAmount.toFixed(2),
    total: total.toFixed(2),
    balance: total
      .minus(money(payments || 0))
      .round(2)
      .toFixed(2),
  };
}

function calculateTaxAmount(items, shipping, tax) {
  let taxableSubtotal = items
    .filter((item) => item.taxable)
    .reduce((sum, item) => sum.plus(money(item.total)), decimal(0));

  if (tax.taxShipping) {
    taxableSubtotal = taxableSubtotal.plus(shipping);
  }

  return taxableSubtotal.times(taxRate(tax.rate)).div('100').round(2);
}
